export default "__VITE_ASSET__BR7YdF8L__"